import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog,MatCheckboxChange} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { TechnologyoverlayService } from '../../../technologyoverlay.service';
import { saveTemplateFloor } from '../../../technologyoverlay';
import { takeUntil } from 'rxjs/operators';
import { SessionCheck, generateAlertMessage, AuthFailedMessage } from '../../../../../app-general';
import {appsettings} from '../../../../../app-settings';
import {Router} from '@angular/router';
import { Http } from '@angular/http';
import { ApiService } from '../../../../../api.service';

const URL = appsettings.URLinfo+'uploadTempImage';

@Component({
  selector: 'app-template-zone',
  templateUrl: './template-zone.component.html',
  styleUrls: ['./template-zone.component.scss']
})

export class TemplateZoneComponent implements OnInit {

  public floorTempateForm : FormGroup;
  selectedFloorId;
  FloorInfo;
  SiteId = "1";
  private _onDestroy: Subject<void> = new Subject<void>();
  SpaceInfo;
  watcher: Subscription;
  columns = 4;
  firstcolumns = 2;
  minheight = "350px"; 
  rowHeight = "79px";
  checkfloortempinfo = false;
  checkfloortempselectall = false;
  select_SpaceIds = [];
  floortempcountchecked_id = 0;
  ZoneImageName = "";
  TempaddImgUrl;
  
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<TemplateZoneComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
  private technologyoverlayService: TechnologyoverlayService, public dialog: MatDialog,public http: Http,private apiService: ApiService) { 
    
    this.selectedFloorId = data.FloorId;
    this.ZoneImageName = data.FloorPlanImage;
    
    this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
      if (change) {
        if (change.mqAlias == 'xs') {
          this.columns = 2;  
          this.firstcolumns = 1;                  
          this.minheight = "auto";
        } 
        else if (change.mqAlias == 'sm') {
          this.columns = 2;
          this.firstcolumns = 2;     
          this.minheight = "auto";
        }  
        else if (change.mqAlias == 'md') {
          this.columns = 2;  
          this.firstcolumns = 2; 
          this.minheight = "350px";               
        }               
       else
       {
         this.columns = 4;  
         this.firstcolumns = 2;      
         this.minheight = "350px";               
       }
      }
    
    });
  }

  ngOnInit() {
    this.floorTempateForm = new FormGroup({
      floorname: new FormControl(''),          
      campusID: new FormControl(''), 
      buildID: new FormControl(''), 
      floorID: new FormControl(''), 
      newtempname:new FormControl('', [Validators.required, Validators.maxLength(32), Validators.pattern(appsettings.Name_Pattern)]),
      description: new FormControl('', [Validators.pattern(appsettings.Name_Pattern)]),
    });
    
    this.floorTempateForm.get('floorname').disable();    
    
    this.getUnitDetails();
  }
  
getUnitDetails()
{
  try
  {
    let voiceLicense = localStorage.getItem("voice_license");
    let buildbyid =  { siteId: this.SiteId,authKey: localStorage.getItem("Authkey"),floorId: this.selectedFloorId, isIndoor: 1, isNeedIntercom: parseInt(voiceLicense), isSubZone: 0 }
    this.apiService.getUnitDetails(buildbyid).pipe(takeUntil(this._onDestroy))
    .subscribe((spaceinfo: any[]) => {
      
      this.SpaceInfo = spaceinfo["apiReturn"];   
      this.SpaceInfo.forEach(function (data)
      {      
          data['DeviceZoneCount'] = data.devicecount + data.Zonedevicecount;       
      });    
    });
  }
  catch(err)
  {
      throw new Error('template-floor.component.ts' + ' - getUnitDetails() - ' + err.message);
  }  
}  

public onCloseCancel = () => 
  { 
    this.thisDialogRef.close('Cancel');  
    if(!SessionCheck(this.router))
    {
        return;
    }         
         
  }

  
  isCheckedAll = false;
  toggleAll(event: MatCheckboxChange) {

    if (event.checked) {
      this.select_SpaceIds = [];
      this.SpaceInfo.forEach(row => {
      
        var checkedid = row.UnitId
        this.select_SpaceIds.push(checkedid)
      });

      
    } else {
      
      this.select_SpaceIds = [];
      this.select_SpaceIds.length = 0;
    }
    this.isCheckedAll = this.isChecked();
  }

toggleresVisibility(checkedid, event: MatCheckboxChange) 
{ 
  if (event.checked) {
      const index = this.select_SpaceIds.indexOf(checkedid);
      if (index == -1) {
        this.select_SpaceIds.push(checkedid);
      }
    } else {
      const index = this.select_SpaceIds.indexOf(checkedid);
      if (index >= 0) {
        this.select_SpaceIds.splice(index, 1);
      }
    }
    this.isCheckedAll = this.isChecked();
}

exists(checkedid) {
  return this.select_SpaceIds.indexOf(checkedid) > -1;
};

isChecked() {
  return this.select_SpaceIds.length === this.SpaceInfo.length;
};

handleInput(event) 
{
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.floorTempateForm.controls).forEach(field => { // {1}
        const control = this.floorTempateForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('template-floor.component.ts' + ' - handleInput() - ' + err.message);
    }
}

public templatefloorDetails = (templatefloorformvalue) => 
  {

    try
    {
      if(!SessionCheck(this.router))
      {
        this.thisDialogRef.close('Cancel');
        return;
      } 
      (document.activeElement as HTMLTextAreaElement).blur();
      if (this.floorTempateForm.valid) { 
        this.saveAsTemplateForFloor(templatefloorformvalue)
      }
    }
    catch(err)
    {
      throw new Error('template-floor.component.ts' + ' - templatefloorDetails() - ' + err.message);
    }
  }
  //When we click the Save as Template, a window will open and it will have the selected zone information and it spaces information. We can choose the spaces. 
  saveAsTemplateForFloor(templatefloorformvalue)
  {
    try
    {
      let saveclick = document.getElementById('btnzonetempsaveclick');
      if (this.select_SpaceIds.length==0 && this.SpaceInfo.length>0)
      {
        generateAlertMessage(this.dialog, 'Must add at least one Space to create as a new Zone Template.');   
        saveclick.className = 'clstempsavebutton mat-raised-button';     
        return;
      }
      if (this.select_SpaceIds.length==0 && this.SpaceInfo.length==0)
      {
        generateAlertMessage(this.dialog, 'Must add at least one Space to duplicate or create as a Template.');   
        saveclick.className = 'clstempsavebutton mat-raised-button';
        return;
      }
      
      saveclick.className = 'clstempsavebutton mat-raised-button disablebtn';
      let templatefloor: saveTemplateFloor = {
        siteId:this.SiteId,
        authKey:localStorage.getItem("Authkey"),
        campusId:parseInt(templatefloorformvalue.campusID),
        buildingId:parseInt(templatefloorformvalue.buildID),
        floorId:parseInt(templatefloorformvalue.floorID),
        tempImageName:this.ZoneImageName,
        templateName:templatefloorformvalue.newtempname.toString(),
        templateDescription:templatefloorformvalue.description.toString(),
        spaceIds:this.select_SpaceIds.toString()
      }
      
      this.technologyoverlayService.saveAsTemplateForFloor(templatefloor).pipe(takeUntil(this._onDestroy))
      .subscribe((apiresponse: any[]) => 
      {           
        
          if(apiresponse.toString() == "true")
          {
            generateAlertMessage(this.dialog, 'Zone Template added successfully.'); 
            saveclick.className = 'clstempsavebutton mat-raised-button';      
            this.thisDialogRef.close("close"); 
            
          }
          else if(apiresponse.toString() == "false")
          {
            generateAlertMessage(this.dialog, 'Zone Template added failed.');   
            saveclick.className = 'clstempsavebutton mat-raised-button';      
            this.thisDialogRef.close('Cancel');             
          }
          else if(apiresponse["condition"] == "Authfalse")
          {
            this.thisDialogRef.close('close');              
            AuthFailedMessage(this.dialog,this.router);  
            return; 
          }
          else if(apiresponse["TemplateNamereturn"].length > 0)
          {                
            generateAlertMessage(this.dialog, "Zone Template name ' " + apiresponse["TemplateNamereturn"] + " ' already exists.");                  
            saveclick.className = 'clstempsavebutton mat-raised-button'; 
            return; 
          }
      })
    }    
    catch(err)
    {
      throw new Error('template-floor.component.ts' + ' - saveAsTemplateForFloor() - ' + err.message);
    }
  }   

}
